import dayjs, { Dayjs } from "dayjs";
import { SelectOption } from "../../../Common/models/form";

const currentDate = dayjs();

export const defaultValues = {
  title: "",
  synopsis: "",
  pageId: "",
  alertTitle: "",
  alertBody: "",
  tools: [""],
  publicationDate: currentDate,
  publicationMode: "draft",
};

export type FaqArticleFormType = typeof defaultValues & {
  tools: string[];
  endDate?: Dayjs;
  isDraft: boolean;
  parentId?: string;
};

export const publicationModeOptions = () =>
  [
    {
      label: "Draft",
      value: "draft",
    },
    {
      label: "Final",
      value: "final",
    },
  ] as SelectOption[];
